import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.grey[50]};
`;

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  align-items: center;

  .btn-back {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 22px 6px 16px;
    gap: 8px;
    width: 125px;
    height: 48px;
    border: 1px solid #212121;
    border-radius: 4px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 14px;
    letter-spacing: 0.5px;
    color: #212121;
  }
`;

export const Title = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  color: #000000;
  margin-bottom: 20px;
`;

export const SectionUser = styled(Box)`
  padding: 30px;
  background: #ffffff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 6px;

  Title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 29px;
    display: flex;
    align-items: center;
    color: #000000;
  }
`;

export const Div = styled(Box)`
  .name-user {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 34px;
    line-height: 42px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.25px;
    color: #000000;
  }

  .active {
    padding: 4px 12px;
    text-align: center;
    width: 57px;
    height: 28px;
    background: #4caf50;
    border-radius: 50px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.15px;
    color: #ffffff;
  }

  .pendent {
    padding: 4px 12px;
    width: 85px;
    height: 28px;
    background: #ffb547;
    border-radius: 50px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.15px;
    color: #ffffff;
  }

  .desactive {
    padding: 4px 12px;
    height: 28px;
    background: #d62237;
    border-radius: 50px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.15px;
    color: #ffffff;
    text-align: center;
  }

  .text-details {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.15px;
    color: #323232;
  }

  span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const SectionBoard = styled(Box)`
  display: grid;
  gap: 20px;
  grid-template-areas: 'board board board board';

  @media (max-width: 1835px) {
    grid-template-areas: 'board board board';
  }

  @media (max-width: 1415px) {
    grid-template-areas: 'board board';
    display: grid;
    justify-content: space-evenly;
  }
  .text-member-board {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #9e9e9e;
  }

  .text-title-board {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;

export const Boards = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: start;
  position: relative;
  padding: 10px 20px;
  justify-content: center;
  width: 340px;
  height: 94px;
  background: #eeeeee;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  border-left: 11px solid;
`;

export const Companies = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px;
  gap: 25px;
  width: 340px;
  height: 90px;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 6px;

  .text-company {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    letter-spacing: 0.15px;
    color: #000000;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

export const Logo = styled(Box)`
  width: 101px;
  height: 70px;

  img {
    width: 101px;
    height: 70px;
  }
`;

export const ContainerCompanies = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 15px;
  flex-wrap: wrap;
`;
